










import calendar from "../../components/calendar.vue"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
    components : {
        calendar
    },
})
export default class CalendarWrapper extends Vue{

    @Prop({}) calDirection:number;
    @Prop({}) newDate:Date;

    scope:string = null;

    mounted(){
        this.$emit('scope','calendar');
        this.checkScope();
        
        window["getCurrentCalendarDate"] = () => {
            if(this.$refs.calendar) {
                let retDate = new Date((this.$refs.calendar as any).focusDate.getTime())
                retDate.setDate(retDate.getDate() - retDate.getDay()); // set to sunday
                return retDate;
            }
            else {
                return new Date();
            }
        }
    }

    calendarFocusChanged() {
        if(window["calendarFocusChanged"]) {
            window["calendarFocusChanged"]();
        }
    }

    checkScope(){
        if(!this.$route.params.calView){
            this.$route.params.calView = "2";
        }
    }

    catchCalUpdate(newCalObject){
        this.$emit("calStateChange", newCalObject)
    }

    @Watch('$route.params.scope')
    changeScope(to,from){
        this.checkScope();
    }
}
